import { useEffect } from 'react';

// Porta o canvas de partículas do hero para React, com limpeza ao desmontar.
export const useHeroParticles = (canvasRef) => {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext('2d');
    let W;
    let H;
    let pts = [];
    let rafId;

    const resize = () => {
      W = canvas.width = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    };

    class Dot {
      constructor() {
        this.init();
      }

      init() {
        this.x = Math.random() * W;
        this.y = Math.random() * H;
        this.r = Math.random() * 1.8 + 0.4;
        this.vx = (Math.random() - 0.5) * 0.25;
        this.vy = (Math.random() - 0.5) * 0.25;
        this.a = Math.random() * 0.45 + 0.08;
        this.c = Math.random() > 0.55 ? '123,92,255' : '255,107,53';
      }

      step() {
        this.x += this.vx;
        this.y += this.vy;
        if (this.x < -10 || this.x > W + 10 || this.y < -10 || this.y > H + 10) this.init();
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${this.c},${this.a})`;
        ctx.fill();
      }
    }

    const glow = () => {
      const g1 = ctx.createRadialGradient(W * 0.28, H * 0.42, 0, W * 0.28, H * 0.42, W * 0.45);
      g1.addColorStop(0, 'rgba(123,92,255,0.07)');
      g1.addColorStop(1, 'transparent');
      ctx.fillStyle = g1;
      ctx.fillRect(0, 0, W, H);

      const g2 = ctx.createRadialGradient(W * 0.72, H * 0.65, 0, W * 0.72, H * 0.65, W * 0.3);
      g2.addColorStop(0, 'rgba(255,107,53,0.045)');
      g2.addColorStop(1, 'transparent');
      ctx.fillStyle = g2;
      ctx.fillRect(0, 0, W, H);
    };

    const loop = () => {
      ctx.clearRect(0, 0, W, H);
      glow();
      pts.forEach((p) => {
        p.step();
        p.draw();
      });
      rafId = requestAnimationFrame(loop);
    };

    const handleResize = () => {
      resize();
      pts.forEach((p) => p.init());
    };

    resize();
    pts = Array.from({ length: 90 }, () => new Dot());
    loop();

    window.addEventListener('resize', handleResize);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', handleResize);
    };
  }, [canvasRef]);
};
